/**
 * tsetsu.* localStorage key. CLAUDE.md §4.3-д жагсаасан key бүхэн.
 * Шинэ key нэмэхдээ зөвхөн энд + AUTH_KEYS массивт нэмнэ.
 */
export const AUTH_KEYS = [
  'tsetsu.token',
  'tsetsu.appUserId',
  'tsetsu.phone',
  'tsetsu.displayName',
  'tsetsu.tenantId',
  'tsetsu.tenantName',
  'tsetsu.companyId',
  'tsetsu.companyName',
  'tsetsu.plan',
  'tsetsu.tenant.json',
] as const;

export type AuthKey = (typeof AUTH_KEYS)[number];

// SSR / prerender (Node) орчинд `localStorage` байхгүй — энэ үед бүх auth
// уншилт null, бичилт no-op болж landing-ийг prerender хийх боломжтой болгоно.
const hasLocalStorage = (): boolean => typeof localStorage !== 'undefined';

export function getAuth(key: AuthKey): string | null {
  if (!hasLocalStorage()) return null;
  return localStorage.getItem(key);
}

export function setAuth(key: AuthKey, value: string | null): void {
  if (!hasLocalStorage()) return;
  if (value == null) localStorage.removeItem(key);
  else localStorage.setItem(key, value);
}

export function clearAuth(): void {
  if (!hasLocalStorage()) return;
  AUTH_KEYS.forEach((k) => localStorage.removeItem(k));
}

export function hasToken(): boolean {
  return !!getAuth('tsetsu.token');
}

export interface AuthSnapshot {
  token: string | null;
  appUserId: string | null;
  phone: string | null;
  displayName: string | null;
  tenantId: string | null;
  tenantName: string | null;
  companyId: string | null;
  companyName: string | null;
  plan: string | null;
}

export function readAuthSnapshot(): AuthSnapshot {
  return {
    token: getAuth('tsetsu.token'),
    appUserId: getAuth('tsetsu.appUserId'),
    phone: getAuth('tsetsu.phone'),
    displayName: getAuth('tsetsu.displayName'),
    tenantId: getAuth('tsetsu.tenantId'),
    tenantName: getAuth('tsetsu.tenantName'),
    companyId: getAuth('tsetsu.companyId'),
    companyName: getAuth('tsetsu.companyName'),
    plan: getAuth('tsetsu.plan'),
  };
}

export interface LoginResponseLike {
  Token: string;
  AppUserId: string;
  Phone?: string | null;
  DisplayName?: string | null;
  DefaultTenantId?: string | null;
  DefaultTenantName?: string | null;
  DefaultCompanyId?: string | null;
  DefaultCompanyName?: string | null;
  Plan?: string | null;
}

export function persistLogin(res: LoginResponseLike): void {
  setAuth('tsetsu.token', res.Token);
  setAuth('tsetsu.appUserId', res.AppUserId);
  if (res.Phone) setAuth('tsetsu.phone', res.Phone);
  if (res.DisplayName) setAuth('tsetsu.displayName', res.DisplayName);
  if (res.DefaultTenantId) setAuth('tsetsu.tenantId', res.DefaultTenantId);
  if (res.DefaultTenantName) setAuth('tsetsu.tenantName', res.DefaultTenantName);
  if (res.DefaultCompanyId) setAuth('tsetsu.companyId', res.DefaultCompanyId);
  if (res.DefaultCompanyName) setAuth('tsetsu.companyName', res.DefaultCompanyName);
  if (res.Plan) setAuth('tsetsu.plan', res.Plan);
}
